// extracted by mini-css-extract-plugin
module.exports = {"section":"PricingPlatformFee_section__JcnsB","title":"PricingPlatformFee_title__LbPQz","caption":"PricingPlatformFee_caption__VD9k0","button":"PricingPlatformFee_button__TGfwl"};